<template>
    <div class="content-error">
        <div class="content-img-error"><img :src="'../../../static/img/' + codeError + '.svg'" width="500px" /></div>
        <div class="content-error-text row">
            <div class="col-4 code-error">{{ codeError }}</div>
            <div class="col-8 text-error">
                {{ $t("error." + codeError + ".error") }} <br />
                {{ $t("error." + codeError + ".errorText") }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: { codeError: { type: String } }
};
</script>

<style scoped lang="scss">
.content-error {
    width: 100%;

    .content-img-error {
        text-align: center;
        margin: 100px 0 50px 0;
    }
}

.content-error-text {
    background-color: #40b3e7;
    width: 500px;
    text-align: center;
    color: #fff;
    margin: auto;
    padding: 20px;

    .code-error {
        font-size: 50px;
    }

    .text-error {
        text-align: left;
        font-size: 25px;
    }
}
</style>



// WEBPACK FOOTER //
// Error.vue?0e6d97d2